import type { RouteId } from "./navigation";

export const customerFacingRouteIds = [
  "account_home",
  "repositories",
  "upload_archive",
  "fleet_agents",
  "inspection_history",
  "waste_index",
  "sdlc_findings",
  "dependency_tracker",
  "feedback_analysis",
  "standards_and_tastes",
  "preference_engine",
  "suppressed",
  "agent_health",
  "agents_md_builder",
  "docs",
  "estate_setup",
  "access",
  "providers",
  "subscriptions",
  "user_settings",
  "api_tokens",
  "notifications",
  "admin",
  "admin_tasks",
  "admin_catalog",
  "cli",
] as const satisfies readonly RouteId[];

export type CustomerFacingRouteId = (typeof customerFacingRouteIds)[number];

/** The Fleet-scoped pages, as their last path segment names them. */
export const fleetPages = ["repositories", "agents", "inspections"] as const;
export type FleetPage = (typeof fleetPages)[number];

export const routeBuilders = {
  // Estate then Fleet, both by id, then what is being looked at. Everything
  // under the Fleet section is of one Fleet, and the Estate is what is billed
  // for what it holds. Names would read better but they get renamed, and a
  // link sent to someone else has to keep opening the same thing.
  fleetScope: (estateId: string, fleetId: string) =>
    `/estate/${encodeURIComponent(estateId)}/fleet/${encodeURIComponent(fleetId)}`,
  fleetPage: (estateId: string, fleetId: string, page: FleetPage) =>
    `${routeBuilders.fleetScope(estateId, fleetId)}/${page}`,
  fleetRepositories: (estateId: string, fleetId: string) =>
    routeBuilders.fleetPage(estateId, fleetId, "repositories"),
  repository: (estateId: string, fleetId: string, repoId: string) =>
    `${routeBuilders.fleetRepositories(estateId, fleetId)}/${encodeURIComponent(repoId)}`,
  scan: (estateId: string, fleetId: string, repoId: string, scanId: string) =>
    `${routeBuilders.repository(estateId, fleetId, repoId)}/scans/${encodeURIComponent(scanId)}`,
  addToFleet: (estateId: string, fleetId: string) =>
    `${routeBuilders.fleetRepositories(estateId, fleetId)}/add`,
  upload: (estateId: string, fleetId: string) =>
    `${routeBuilders.fleetRepositories(estateId, fleetId)}/upload`,
  inspectionHistory: (estateId: string, fleetId: string, repoId?: string) =>
    `${routeBuilders.fleetPage(estateId, fleetId, "inspections")}` +
    (repoId ? `?repository=${encodeURIComponent(repoId)}` : ""),
  task: (estateId: string, fleetId: string, taskId: string) =>
    `${routeBuilders.fleetScope(estateId, fleetId)}/tasks/${encodeURIComponent(taskId)}`,
};
